<template>
  <fragment>
    <AppBody title="Pessoas / Usuários" subtitle="Cadastrar - Editar">
      <div class="pessoas-usuarios-add-edit-container02 base">
        <v-col
          cols="3"
          align-self="center"
          v-if="!$pessoas_usuarios.cadastro.avatar.imagem"
          class="avatar-container"
        >
          <!-- <svg viewBox="0 0 1024 1024" class="upload-icon">
            <path
              d="M512 598q108 0 225 47t117 123v86h-684v-86q0-76 117-123t225-47zM512 512q-70 0-120-50t-50-120 50-121 120-51 120 51 50 121-50 120-120 50z"
            ></path>
          </svg> -->
          <UploadIcon customizedClass="upload-icon" />
          <v-file-input
            show-size
            accept="image/png, image/jpeg, image/bmp"
            :rules="rules"
            placeholder="Selecione uma foto de perfil"
            append-icon="mdi-paperclip"
            prepend-icon=""
            v-model="$pessoas_usuarios.cadastro.avatar.object"
            @change="getImagem($pessoas_usuarios.cadastro.avatar.object)"
          ></v-file-input>
        </v-col>

        <v-col cols="3" align-self="center" v-else class="avatar-container-pic">
          <v-avatar width="150" height="150">
            <label for="imagemupload" class="avatar-label">
              <v-icon class="image-icon">{{ $config.icons.cameraFlip }}</v-icon>
              <v-img
                max-height="180"
                max-width="160"
                :src="$pessoas_usuarios.cadastro.avatar.imagem"
              >
              </v-img>
              <v-file-input
                id="imagemupload"
                show-size
                accept="image/png, image/jpeg, image/bmp"
                :rules="rules"
                append-icon="mdi-paperclip"
                prepend-icon=""
                placeholder="Escolha uma foto para atualizar"
                style="display: none"
                v-model="$pessoas_usuarios.cadastro.avatar.object"
                @change="getImagem($pessoas_usuarios.cadastro.avatar.object)"
              ></v-file-input>
            </label>
          </v-avatar>
        </v-col>

        <v-col cols="4" align-self="center">
          <label required class="input-labels"> Nome </label>
          <v-text-field
            solo
            placeholder="Ex: João da Silva"
            v-model="$pessoas_usuarios.cadastro.nome"
            type="text"
            class="textinput"
            :error-messages="$pessoas_usuarios.cadastro.error.nome"
            @input="$pessoas_usuarios.cadastro.error.nome = []"
          ></v-text-field>
        </v-col>
        <v-col cols="4" align-self="center">
          <label required class="input-labels"> E-mail </label>
          <v-text-field
            solo
            required
            placeholder="seuemail@email.com"
            v-model="$pessoas_usuarios.cadastro.email"
            type="email"
            class="textinput"
            :error-messages="$pessoas_usuarios.cadastro.error.email"
            @input="$pessoas_usuarios.cadastro.error.email = []"
          ></v-text-field>
        </v-col>
        <v-col
          cols="4"
          align-self="center"
          v-if="$pessoas_usuarios.usuarioAddEdit == 'new'"
        >
          <label required class="input-labels"> Senha </label>
          <v-text-field
            solo
            required
            placeholder="******"
            v-model="$pessoas_usuarios.cadastro.senha"
            class="textinput"
            :type="showSenha ? 'text' : 'password'"
            :append-icon="
              showSenha ? $config.icons.viewOff : $config.icons.view
            "
            @click:append="showSenha = !showSenha"
            color="#353535"
            :error-messages="$pessoas_usuarios.cadastro.error.senha"
            @input="$pessoas_usuarios.cadastro.error.senha = []"
          ></v-text-field>
        </v-col>
        <v-col cols="4" align-self="center">
          <label required class="input-labels"> Status </label>
          <v-select
            height="48"
            :items="status"
            item-text="key"
            item-value="value"
            dense
            solo
            class="textinput"
            v-model="$pessoas_usuarios.cadastro.status"
            required
            placeholder="Selecione o status"
            :error-messages="$pessoas_usuarios.cadastro.error.status"
            @input="$pessoas_usuarios.cadastro.error.status = []"
          ></v-select>
        </v-col>
        <!-- <div class="pessoas-usuarios-add-edit-container10">
                    <div class="pessoas-usuarios-add-edit-container11">
                        <h1 class="pessoas-usuarios-add-edit-text08">Perfis</h1>
                        <div class="pessoas-usuarios-add-edit-container12">
                            <div class="pessoas-usuarios-add-edit-container13">
                                <div class="pessoas-usuarios-add-edit-container14">
                                    <span>Adicionar</span>
                                </div>
                                <div class="pessoas-usuarios-add-edit-container15">
                                    <span>Remover</span>
                                </div>
                            </div>
                            <div class="pessoas-usuarios-add-edit-container16">
                                <div class="pessoas-usuarios-add-edit-container17">
                                    <div class="pessoas-usuarios-add-edit-container18" v-for="(perfil, index) in perfis" :key="index" @click="setProfile(perfis, perfil, index)">
                                        <span>{{perfil}}</span>
                                        <svg viewBox="0 0 1024 1024" class="pessoas-usuarios-add-edit-icon">
                                            <path d="M366 708l196-196-196-196 60-60 256 256-256 256z"></path>
                                        </svg>
                                    </div>
                                </div>
                                <div class="pessoas-usuarios-add-edit-container19">
                                    <div class="pessoas-usuarios-add-edit-container20" v-for="(perfil, index) in $pessoas_usuarios.cadastro.perfil" :key="index" @click="removeProfile(cadastro.perfil, perfil, index)">
                                        <span>{{perfil}}</span>
                                        <svg viewBox="0 0 1024 1024" class="pessoas-usuarios-add-edit-icon02">
                                            <path d="M658 708l-60 60-256-256 256-256 60 60-196 196z"></path>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
      </div>
      <RegistrationActions
        :fixed="true"
        :loader="$pessoas_usuarios.cadastro.loading"
        :actions="actions"
      />
    </AppBody>
  </fragment>
</template>

<script>
export default {
  name: "UsuariosSettings",
  components: {
    AppBody: () => import("@/layouts/components/AppBody.vue"),
    RegistrationActions: () =>
      import("@/components/global/RegistrationActions.vue"),
    UploadIcon: () => import("@/components/icons/UploadIcon.vue"),
  },
  metaInfo: {
    title: "Pessoas/Usuarios | Adicionar/Editar | ElevenTickets",
    meta: [
      {
        property: "og:title",
        content: "Pessoas/Usuarios | Adicionar/Editar | ElevenTickets",
      },
    ],
  },
  data() {
    return {
      actions: [
        {
          name: "Salvar",
          action: () => this.$pessoas_usuarios.validarCadastro(),
        },
        {
          name: "Cancelar",
          action: () => this.$axios.rota("/pessoas/usuarios"),
        },
      ],
      cadastro: {
        perfil: [],
      },
      showSenha: false,
      perfis: [
        "Operações",
        "Atendimento B2B",
        "Atendimento B2C",
        "Configurador",
        "Financeiro",
        "Analista",
        "Gerente",
        "Diretor",
        "Jurídico",
        "Admin",
        "Comercial",
      ],
      status: [
        {
          key: "Ativo",
          value: "ATIVO",
        },
        {
          key: "Inativo",
          value: "INATIVO",
        },
      ],
      rules: [
        v =>
          !v ||
          v.size < 400000 ||
          "A imagem deve ter o tamanho máximo de 400KB!",
      ],
    };
  },
  methods: {
    setProfile(array, profile) {
      var profileIndex = this.perfis.indexOf(profile);
      if (profileIndex > -1) {
        this.perfis.splice(profileIndex, 1);
      }
      this.$pessoas_usuarios.cadastro.perfil.push(profile);
    },
    removeProfile(array, profile) {
      var profileIndex =
        this.$pessoas_usuarios.cadastro.perfil.indexOf(profile);
      if (profileIndex > -1) {
        this.$pessoas_usuarios.cadastro.perfil.splice(profileIndex, 1);
      }
      this.perfis.push(profile);
    },
    getImagem(file) {
      const self = this;
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        self.$pessoas_usuarios.cadastro.avatar.imagem = reader.result;
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
    },
    btnBack() {
      this.$axios.rota("pessoas-usuarios");
      this.$pessoas_usuarios.limpaFormularioDeUsuario();
    },
  },
  destroyed() {
    this.$pessoas_usuarios.limpaFormularioDeUsuario();
  },
};
</script>

<style scoped>
.pessoas-usuarios-add-edit-container02 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  position: relative;
  align-items: flex-start;
  padding-top: 1.25rem;
  padding-left: 15px;
  border-radius: 20px;
  padding-right: 15px;
  flex-direction: column;
  padding-bottom: 1.25rem;
  justify-content: flex-start;
  background-color: #eaeaea;
}

.upload-icon {
  height: 10rem !important;
  width: 10rem !important;
}
</style>
